// extracted by mini-css-extract-plugin
export default {"vertical-icon":"CalendarPanel_vertical-icon__N6hUT","icon":"CalendarPanel_icon__iBYXc"};